import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteMercanciaGuiasIdentificacionForm from './CartaPorteMercanciaGuiasIdentificacionForm';
import CartaPorteMercanciaGuiasIdentificacionList from './CartaPorteMercanciaGuiasIdentificacionList';

class CartaPorteMercanciaGuiasIdentificacionManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { GuiasIdentificacion = [] } = this.props.data;

    const newData = GuiasIdentificacion.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      GuiasIdentificacion: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { GuiasIdentificacion =  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Guias Identificacion</legend>

          <CartaPorteMercanciaGuiasIdentificacionForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteMercanciaGuiasIdentificacionList
            data={ GuiasIdentificacion }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteMercanciaGuiasIdentificacionManager;